
import axios from "axios";
import {
  TOKEN,
  ORGANIZATION_ID,
  USER_ID,
  WORKSPACE_ID,
} from "../../constants/enums";

const CORE_API = process.env.REACT_APP_CORE_API || "https://prod-api.indxx.com";

export default async function callApi(
  endpoint: string,
  method: "post" | "get" = "post",
  body?: any
) {
  let headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  const authUser = window.localStorage.getItem(TOKEN);
  if (authUser) {
    try {
      const token = JSON.parse(authUser);
      if (token && token !== "") {
        headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // Handle invalid JSON silently
    }
  }

  try {
    const response = await axios({
      url: `${CORE_API}/api/${endpoint}`,
      method,
      data: body,
      headers,
    });

    return response.data;
  } catch (error: any) {
    console.error("❌ callApi error:", error);
    
    // Handle 401 Unauthorized - redirect to login
    if (error?.response?.status === 401) {
      console.log("🔐 401 Error - Clearing auth data");

      // Tell the login page why we got here (signed in elsewhere or session ended).
      if (error?.response?.data?.data?.code === "SESSION_REVOKED") {
        window.sessionStorage.setItem("session_revoked", "1");
      }

      window.localStorage.removeItem(TOKEN);
      window.localStorage.removeItem(ORGANIZATION_ID);
      window.localStorage.removeItem(USER_ID);
      window.localStorage.removeItem(WORKSPACE_ID);
      
      // Only redirect if NOT already on login page
      const currentPath = window.location.pathname;
      console.log("📍 Current path:", currentPath);
      
      if (currentPath !== "/login") {
        console.log("🔄 Redirecting to /login");
        window.location.href = "/login";
      } else {
        console.log("⚠️ Already on login page, not redirecting");
        // Throw error so the login form can handle it
        const errorObject = {
          status: 401,
          message: "Invalid credentials. Please try again.",
          data: error?.response?.data || null,
          originalError: error
        };
        throw errorObject;
      }
      return;
    }
    
    // For other errors, throw a structured error object
    const errorObject = {
      status: error?.response?.status || 500,
      message: error?.response?.data?.message || 
               error?.response?.data?.data?.message ||
               error?.message || 
               "An unexpected error occurred",
      data: error?.response?.data || null,
      originalError: error
    };
    
    console.log("❌ Throwing error:", errorObject);
    throw errorObject;
  }
}